<ng-template #titleTemplate>
  {{ title }}
</ng-template>

<ng-template #descriptionTemplate>
  {{
    "AstroBin's equipment database is entirely maintained by the community. Feel free to make a contribution!"
      | translate
  }}
  <a class="learn-more" href="https://welcome.astrobin.com/features/equipment-database" target="_blank">
    {{ "Learn more" }}.
  </a>
</ng-template>

<ng-template #navTemplate>
  <astrobin-equipment-item-type-nav #itemTypeNavComponent></astrobin-equipment-item-type-nav>
</ng-template>

<div
  *ngIf="activeType"
  [class.compare-component-visible]="compareComponentVisible"
  class="page has-breadcrumb has-title"
>
  <astrobin-upgrade-nudge></astrobin-upgrade-nudge>

  <ng-container *ngIf="breakpointMdMin">
    <h1><ng-container [ngTemplateOutlet]="titleTemplate"></ng-container></h1>
    <small><ng-container [ngTemplateOutlet]="descriptionTemplate"></ng-container></small>
  </ng-container>

  <div class="row g-0 g-3">
    <div *ngIf="breakpointMdMin" class="col-md-4 col-xl-3">
      <ng-container [ngTemplateOutlet]="navTemplate"></ng-container>
    </div>

    <div class="col-md-8 col-xl-9">
      <astrobin-equipment-explorer
        #explorer
        [activeEditProposalId]="activeEditProposalId"
        [activeId]="activeId"
        [activeType]="activeType"
        [goBackOnClose]="goBackOnClose"
        (creationMode)="creationMode = $event"
        (valueChanged)="onSelectedItemChanged($event)"
      ></astrobin-equipment-explorer>

      <ng-container *ngIf="!activeId && !creationMode">
        <astrobin-equipment-explorer-filters
          #explorerFilters
          [activeFilters]="filters"
          [type]="activeType"
          (applied)="filtersApplied()"
          class="d-block mb-3"
        ></astrobin-equipment-explorer-filters>

        <ng-container *ngIf="items$ | async as items; else loading">
          <table class="table table-striped table-bordered items">
            <thead>
              <tr>
                <th>
                  <button (click)="toggleAZSorting()" class="btn btn-link btn-no-block">
                    {{ equipmentItemService.getPrintablePropertyName(null, EquipmentItemDisplayProperty.NAME, true) }}
                    <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.AZ_DESC" icon="sort-alpha-down"></fa-icon>
                    <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.AZ" icon="sort-alpha-up"></fa-icon>
                  </button>
                </th>
                <th>
                  <button (click)="toggleUsersSorting()" class="btn btn-link btn-no-block">
                    {{ "Users" | translate }}
                    <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.USERS_DESC" icon="sort-numeric-down"></fa-icon>
                    <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.USERS" icon="sort-numeric-up"></fa-icon>
                  </button>
                </th>
                <th>
                  <button (click)="toggleImagesSorting()" class="btn btn-link btn-no-block">
                    {{ "Images" | translate }}
                    <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.IMAGES_DESC" icon="sort-numeric-down"></fa-icon>
                    <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.IMAGES" icon="sort-numeric-up"></fa-icon>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items.results; trackBy: equipmentItemService.trackBy" data-id="{{ item.id }}">
                <td class="item-name">
                  <a
                    [href]="'/equipment/explorer/' + item.klass.toLowerCase() + '/' + item.id"
                    (click)="viewItem(item)"
                    astrobinEventPreventDefault
                  >
                    <astrobin-equipment-item-display-name
                      [item]="item"
                      [showFrozenAsAmbiguous]="item.variants?.length === 0"
                    ></astrobin-equipment-item-display-name>
                    <span
                      *ngIf="item.variants?.length > 0"
                      [innerHTML]="'+ {{numVariants}} variants' | translate: { numVariants: item.variants.length }"
                      class="variant-count"
                    >
                    </span>
                  </a>
                  <a (click)="search(item)" class="search" astrobinEventPreventDefault href="#">
                    <fa-icon icon="search"></fa-icon>
                  </a>
                  <a
                    *ngIf="
                      [
                        EquipmentItemType.CAMERA,
                        EquipmentItemType.SENSOR,
                        EquipmentItemType.TELESCOPE,
                        EquipmentItemType.FILTER,
                        EquipmentItemType.MOUNT
                      ].indexOf(activeType) > -1
                    "
                    (click)="compareService.addWithErrorHandling(item)"
                    class="add-to-compare"
                    astrobinEventPreventDefault
                    href="#"
                  >
                    <fa-icon [ngbTooltip]="'Add to comparison list' | translate" icon="list-alt"></fa-icon>
                  </a>
                </td>
                <td>{{ item.userCount }}</td>
                <td>{{ item.imageCount }}</td>
              </tr>
            </tbody>
          </table>

          <astrobin-nothing-here *ngIf="items.count === 0"></astrobin-nothing-here>

          <ngb-pagination
            *ngIf="items.count > items.results.length"
            [collectionSize]="items.count"
            (pageChange)="pageChange($event)"
            [(page)]="page"
          >
            <ng-template ngbPaginationPrevious>&larr;</ng-template>
            <ng-template ngbPaginationNext>&rarr;</ng-template>
          </ngb-pagination>
        </ng-container>
      </ng-container>
    </div>
    <!-- item div -->
  </div>

  <astrobin-equipment-compare (visibilityChanged)="compareComponentVisible = $event"></astrobin-equipment-compare>
</div>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
